// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52f8f39f","455":"1cb12485","977":"9be64387"}[chunkId] + ".chunk.js";
};